// extracted by mini-css-extract-plugin
export default {"overlay":"Overlayform_overlay__RZoFf","children":"Overlayform_children__VOfnn"};